var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { platformIconMap } from 'root/src/shared/constants/dropKeys';
export function GamePlatformIcon(props) {
    const { platform } = props, rest = __rest(props, ["platform"]);
    const icon = platformIconMap[platform];
    if (!icon) {
        return null;
    }
    return <FontAwesomeIcon icon={icon} {...rest}/>;
}
